import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { validatorTypes } from "@data-driven-forms/react-form-renderer";
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { ACTIONS } from "../../../common/Constants";
import { getValue } from "../../../../utils/common";
import { GetActionTitle, RuleType } from "../Master.constants";
import { useCreateRule, useUpdateRule } from "../../../../backend/masters";
import { toast } from "react-toastify";
import { ERROR_MESSAGES } from "../../../../utils/constants";
import PageLoader from "../../../shared/PageLoader";
import { ResponseModel } from "../../../../models/responseModel";

function AddEditRule({ action, record : data, onClose, onSubmit }: any) {
    const [form, setForm] = useState<any>({});
    const [ruleDetails, setRuleDetails] = useState<any>({ hideButtons: true });
    const { createRule, isLoading: creatingRule } = useCreateRule((rule: ResponseModel) => {
        if (rule && rule.error_messages.length > 0) {
            toast.error(rule.error_messages.join(', '));
        } else {
            toast.success(`${form.values.name.trim()} created successfully.`);
            onSubmit();
        }
    }, errorCallback);

    const { updateRule, isLoading: updatingRule } = useUpdateRule((rule: ResponseModel) => {
        if (rule && rule.error_messages.length > 0) {
            toast.error(rule.error_messages.join(', '));
        } else {
            toast.success(`${form.values.name.trim()} updated successfully.`);
            onSubmit();
        }
    }, errorCallback);

    function errorCallback() {
        toast.error(ERROR_MESSAGES.DEFAULT)
    }

    const schema = {
        fields: [
            {
                component: componentTypes.INPUT_AS_TEXT,
                name: 'name',
                label: 'Rule Name',
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
                content: getValue(ruleDetails, 'name')
            },
            {
                component: componentTypes.TEXTAREA,
                name: 'description',
                label: 'Description',
                content: getValue(ruleDetails, 'description') || '-NA-',
                validate: [
                    { type: validatorTypes.MAX_LENGTH, threshold: 999 }
                ],
            },
            {
                component: componentTypes.SELECT,
                name: 'type',
                label: 'Type',
                content: '',
                options: RuleType.map(x => {
                    return { id: x, name: x }
                }),
                validate: [
                    { type: validatorTypes.REQUIRED }
                ],
            },
            {
                component: componentTypes.TEXT_FIELD,
                name: 'section_no',
                label: 'Section No.',
                validate: [
                    { type: validatorTypes.REQUIRED },
                    { type: validatorTypes.MAX_LENGTH, threshold: 50 }
                ],
                content: getValue(ruleDetails, 'section_no')
            },
            {
                component: componentTypes.TEXT_FIELD,
                name: 'rule_no',
                label: 'Rule No.',
                validate: [
                    { type: validatorTypes.REQUIRED },
                    { type: validatorTypes.MAX_LENGTH, threshold: 50 }
                ],
                content: getValue(ruleDetails, 'rule_no')
            },
            {
                component: componentTypes.INPUT_AS_TEXT,
                name: 'unique_identifier',
                label: 'Unique Identifier',
                validate: [
                    { type: validatorTypes.REQUIRED },
                    { type: validatorTypes.MAX_LENGTH, threshold: 100 }
                ],
                content: getValue(ruleDetails, 'unique_identifier')
            }
        ],
    };

    function submitData() {
        if (form.valid) {
            const { name, description, type, section_no, rule_no, unique_identifier } = form.values || {};
            const payload: any = {
                name: name.trim(),
                description: (description || '').trim(),
                type: type.value,
                section_no,
                rule_no,
                unique_dentifier: unique_identifier.trim(),
            }
            if (action === ACTIONS.ADD) {
                createRule(payload);
            } else if (action === ACTIONS.EDIT) {
                payload['id'] = data.id;
                updateRule(payload);
            }
        }
    }

    useEffect(() => {
        if (data) {
            setRuleDetails({
                ...ruleDetails, ...data,
                type: { value: data.rule_type, label: data.rule_type }
            });
        }
    }, [data]);

    return (
        <>
            <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
                <Modal.Header closeButton={true} onHide={onClose}>
                    <Modal.Title className="bg">{GetActionTitle('Rule', action)}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormRenderer FormTemplate={FormTemplate}
                        initialValues={ruleDetails}
                        componentMapper={ComponentMapper}
                        schema={schema}
                        debug={setForm}
                    />
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    {
                      <>
                        <Button variant="outline-secondary" className="btn btn-outline-secondary px-4" onClick={onClose}>{'Cancel'}</Button>
                        <Button variant="primary" onClick={submitData} className="px-4" disabled={!form.valid}>{'Submit'}</Button>
                      </>

                    }
                </Modal.Footer>
            </Modal>
            {
                creatingRule && <PageLoader message="Creating Rule..." />
            }
            {
                updatingRule && <PageLoader message="Updating Rule..." />
            }
        </>
    )
}

export default AddEditRule;
